import { ID } from '@datorama/akita';

import { Entity } from '../entity';
import { LanguagePage, PageTitles } from '../interfaces/types';
import { IEntity } from '../interfaces/models';

export interface IConfig extends IEntity {
  name: string;
  type: string;
  value: string;
}

@Entity({
  name: PageTitles.systemConfig,
  language: LanguagePage.systemConfig,
})
export class Config implements IConfig {
  id: ID;
  name: string;
  type: string;
  value: string;
  createdAt?: Date;
  modifiedAt?: Date;
  createdBy?: string;
  modifiedBy?: string;
  href?: string;

  constructor(
    config: IConfig = {
      id: '',
      name: '',
      type: '',
      value: '',
    }
  ) {
    const { id, name, type, value } = config;

    this.id = id;
    this.name = name;
    this.type = type;
    this.value = value;
  }

  static createFromDTO(record: IConfig): Config {
    return new Config({
      ...record,
      modifiedAt: record.modifiedAt ? new Date(record.modifiedAt) : null,
      createdAt: record.createdAt ? new Date(record.createdAt) : null,
    });
  }
}
